import type { PriorityPlaylist } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (playlists: PriorityPlaylist[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Suggested Playbooks',
    description:
      'System-recommended playbooks; Add Playbook copies one into the user’s playbooks and opens it',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'Suggested playbooks available to the user',
    data: { suggestedPlaylists: playlists },
  });
};
